import { Button, Grid, Box, IconButton, Stack, Typography, Radio, TextField as MuiTextField } from '@mui/material';
import { useForm } from 'react-hook-form';
import CloseIcon from '@mui/icons-material/Close';
import { FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { dropdownFetch } from '../../../../../utils';
import axios from 'axios';
import { BASE_URL } from '../../../../../utils';

export const IntakeBloodDetailsForm = ({
  onClose,
  onAdd,
  bloodGroupDropdown,
  componentDropdown
}) => {

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        component: Yup.string().required('Please select Doctor'),
        blood_group: Yup.string().required('Please select Service')
      })
    ),
    defaultValues: {
      purchase_details:{
        quantity: 1,
        rate: 0,
        amount: 0,
      }
    },
    mode: 'all'
  });
  const { reset } = methods;

  const { handleSubmit, setValue, watch } = methods;

  const formSubmitHandler = (formValues) => {
   
    formValues.gst_per = +formValues.gst_per;
    formValues.disc_per = +formValues.disc_per;
    formValues.quantity = +formValues.quantity;
    const transformedValues = {
      ...formValues,
      sold_details:{
        ...formValues.purchase_details
      }
    };
    onAdd(transformedValues);
    console.log(transformedValues,"TRANSFORMED VALUES")
  };


  const rateWatch = watch('purchase_details.rate');
  const quantityWatch = watch('purchase_details.quantity');
  const discPerWatch = watch('purchase_details.disc_per');
  const gstPerWatch = watch('purchase_details.gst_per');
  const discAmtWatch = watch('purchase_details.disc_amt');

  useEffect(() => {
    const amount = rateWatch * quantityWatch;
    const discAmt = parseFloat(((amount * discPerWatch) / 100).toFixed(2));
    const gstAmt = parseFloat((((amount - discAmt) * gstPerWatch) / 100).toFixed(2));
    const netAmt = parseFloat((amount - discAmt + gstAmt).toFixed(2));
    setValue('purchase_details.amount', parseFloat(amount.toFixed(2)));
    setValue('purchase_details.disc_amt', discAmt);
    setValue('purchase_details.gst_amt', gstAmt);
    setValue('purchase_details.net_amt', netAmt);
  }, [rateWatch, quantityWatch, discPerWatch, gstPerWatch, setValue]);

  useEffect(() => {
    if (rateWatch && quantityWatch && discAmtWatch !== undefined) {
      const amount = rateWatch * quantityWatch;
      const newDiscPer = parseFloat(((discAmtWatch / amount) * 100).toFixed(6));
      setValue('purchase_details.disc_per', newDiscPer);
    }
  }, [rateWatch, quantityWatch, discAmtWatch, setValue]);

  return (
    <Stack spacing={1} sx={{ height: '100%' }}>
      <Stack direction="row" spacing={0} alignItems="center" justifyContent="space-between" borderColor="grey.300">
        <Typography variant="h4" fontWeight="bold">
          Add Blood Intake Details
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" fontSize="large" />
        </IconButton>
      </Stack>
      <FormProvider
        sx={{ height: '100%', overflow: 'auto' }}
        methods={methods}
        onSubmit={handleSubmit(formSubmitHandler)}
      >
        <Grid container spacing={1} sx={{ flex: 1, height: '100%', overflow: 'auto' }}>
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.2, px: 2 }}>
            <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Blood Group</Typography>
                <SelectTag menus={bloodGroupDropdown.map((data) => ({ ...data, name: data.group }))} formControlSX={{ flex: 0.8 }} name="blood_group" placeholder="Select Blood Group" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Component Name</Typography>
                <SelectTag
                menus={componentDropdown.map((data)=> ({...data,name:data?.component}))}
                  formControlSX={{ flex: 0.8 }}
                  name="component"
                  placeholder="Enter Component Name"
                />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Batch No</Typography>
                <TextField
                  sx={{ flex: 0.8 }}
                  name="batch_no"
                  placeholder="Enter Batch No."
                />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Serial No.</Typography>
                <TextField
                  sx={{ flex: 0.8 }}
                  name="serial_no"
                  placeholder="Enter Serial No."
                />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Exp Date</Typography>
                <TextField
                  sx={{ flex: 0.8 }}
                  name="exp_date"
                  type="month"
                />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Quantity</Typography>
                <TextField
                  sx={{ flex: 0.3 }}
                  type="number"
                  inputProps={{ min: '0' }}
                  name="purchase_details.quantity"
                  placeholder="Quantity"
                  disabled
                />
                <Typography sx={{ flex: 0.1, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
                <TextField sx={{ flex: 0.35 }} name="purchase_details.rate" placeholder="Rate" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center">
                <Typography sx={{ flex: 0.3, fontWeight: 700, fontSize: '1.4rem' }}>Amount</Typography>
                <TextField disabled sx={{ flex: 0.8 }} name="purchase_details.amount"  placeholder="amount" />
              </Stack>
              <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" sx={{marginTop:"2%"}}>
                <Button variant="contained" type="submit">
                  Add
                </Button>
                <Button variant="outlined" onClick={onClose} color="error">
                  Close
                </Button>
              </Stack>
            </Box>
          </Grid>
        </Grid>
      </FormProvider>
    </Stack>
  );
};
